import { defineComponent } from 'vue'
import throttle from 'lodash/throttle'

export default defineComponent({
    data() {
        const vm = this as { $logger?: { info: (message: string) => void } }
        return {
            // Built per instance: a throttled function declared on `methods` is created once at
            // mixin-definition time, so every field would share one 1000ms window and typing in
            // one field would drop the next field's log.
            throttleLogging: throttle((inputValue: string, logPrefix = '') => {
                if (inputValue) {
                    vm.$logger?.info(`${logPrefix}: ${inputValue}`)
                }
            }, 1000),
        }
    },
    methods: {
        throttleAnalytics: throttle((eventName, eventProps): any => {
            if (eventName) {
                // @ts-ignore
                window.logEvent(eventName, eventProps)
            }
        }, 4000),
    },
})
